import React from "react";
import PropTypes from 'prop-types'
import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import { LocalLibrary } from "@material-ui/icons";
import Input from '@material-ui/core/Input'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import SettingStore from '../stores/SettingStore'
import db from "../db.js";
const data = db();

const styles = theme => ({
  root: {
    height: 40,
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.secondary.main + '8c',
  },
  input: {
    width: '90%',
    border: '1px inset #000',
    borderRadius: '5px',
  },
  searchContainer: {
    margin: '16px',
    width: '100%',
  },
  regularContainer: {
    marginLeft: '16px',
    width: '100%',
  }
})

class SupportSearch extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      focus: true,
      value: this.props.value,
      res : [],
      active: false

    }
  }

  handleFocus = (e) => {
    this.setState({focus: true})
    if (this.props.onFocus) {
      this.props.onFocus(e)
    }
  }

  handleBlur = (e) => {
    this.setState({focus: false})
    if (this.state.value.trim().length === 0) {
      this.setState({value: ''})
    }
    if (this.props.onBlur) {
      this.props.onBlur(e)
    }
  }

  handleInput = (e) => {
    this.setState({value: e.target.value})
    if (this.props.onChange) {
    }
  }

  handleCancel = () => {
    this.setState({active: false, value: ''})
    this.props.onChange && this.props.onChange('')
  }

  handleKeyUp = (e) => {
    if (e.charCode === 13 || e.key === 'Enter') {
      SettingStore.supportSearch(this.state.value).then(r => {
            this.setState({ res: r.data });
          });
    }
    if (this.props.onKeyUp) {
      this.props.onKeyUp(e)
    }
  }

  componentDidMount() {
    document.title = "GO | Soporte";
  }

  render() {

    const {value, res} = this.state
    const {
      classes,
      closeIcon,
      disabled,
      onRequestSearch, // eslint-disable-line
      searchIcon,
      style,
    } = this.props
    let ws_res = <Typography  className={classes.regularContainer} variant="body1" gutterBottom align="left">No hay resultados</Typography>;
    if(res.length > 0){
      ws_res = (
        <React.Fragment>
        <Table padding="dense" spacing={0} align="nowrap">
          <TableHead>
            <TableRow>
              <TableCell>Clave de empleado</TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell>Area</TableCell>
              <TableCell>Corto</TableCell>
              <TableCell>Depto</TableCell>
              <TableCell>Corto</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Ciudad</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {res.map(r=>{
            return(
              <TableRow key={r['cve_empleado']}>
                <TableCell>{r['cve_empleado']}</TableCell>
                <TableCell>{r['Nombre']}</TableCell>
                <TableCell>{r['NombreArea']}</TableCell>
                <TableCell>{r['DescCortaArea']}</TableCell>
                <TableCell>{r['depto']}</TableCell>
                <TableCell>{r['Descdepto']}</TableCell>
                <TableCell>{r['correoelec']}</TableCell>
                <TableCell>{r['UbicacionDepartamento']}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
        </React.Fragment>);
    }

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginBottom: 25 }}>
            <Typography variant="h6" className={classes.regularContainer}>
              Busqueda en Web Service
            </Typography>
            <div className={classes.searchContainer}>
              <Input
                onBlur={this.handleBlur}
                value={value}
                onChange={this.handleInput}
                onKeyUp={this.handleKeyUp}
                onFocus={this.handleFocus}
                className={classes.input}
                fullWidth
                disableUnderline
                disabled={disabled}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginBottom: 25 }}>
            <div>
            {ws_res}
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}
SupportSearch.defaultProps = {
  disabled: false,
  placeholder: 'Buscar',
  style: null,
  value: ''
}

SupportSearch.propTypes = {
  /** Override or extend the styles applied to the component. */
  classes: PropTypes.object.isRequired,
  /** Override the close icon. */
  closeIcon: PropTypes.node,
  /** Disables text field. */
  disabled: PropTypes.bool,
  /** Sets placeholder for the embedded text field. */
  placeholder: PropTypes.string,
  /** Fired when the text value changes. */
  onChange: PropTypes.func,
  /** Override the search icon. */
  searchIcon: PropTypes.node,
  /** Override the inline-styles of the root element. */
  style: PropTypes.object,
  /** The value of the text field. */
  value: PropTypes.string
}

export default withStyles(styles)(SupportSearch);



// WEBPACK FOOTER //
// ./src/components/SupportSearch.js